/**
 * @param {array} paths
 * @param {function} middleware
 * @returns {function(*=, *=, *=): *}
 */
function useMiddlewareUnless (paths, middleware) {
  return (req, res, next) => {
    const noMiddleware = paths.some(path => req?.path?.startsWith(path))

    return noMiddleware
      ? next()
      : middleware(req, res, next)
  }
}

module.exports = { useMiddlewareUnless }
